import styled from 'styled-components';

export const Container = styled.div`
    padding: 24px;
    height: calc(80vh - 55px);
    overflow-y: auto;
    display: flex;
    flex-direction: column;
`;

export const TableWrapper = styled.div`
    flex: 1;
    overflow-y: auto;
`;

export const StoresArea = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
    overflow-y: auto;
    margin-top: 24px;
`;

export const StoresTitle = styled.h2`
    font-size: 16px;
    font-weight: 500;
    color: ${({ theme }) => (theme.theme === 'dark' ? '#fff' : '#30374a')};
    margin: 0px;
`;

export const StatusPlanogram = styled.div<{ status: boolean }>`
    height: 24px;
    padding: 0px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    gap: 8px;
    font-weight: 400;
    border-radius: 2px;
    user-select: none;
    width: fit-content;
    background: ${({ status, theme }) => {
        if (theme.theme === 'dark') {
            return status
                ? 'rgba(56, 158, 13, 0.18)'
                : 'rgba(47, 84, 235, 0.2)';
        }

        return status ? '#F6FFED' : '#F0F5FF';
    }};

    color: ${({ status, theme }) => {
        if (theme.theme === 'dark') {
            return status ? '#95DE64' : '#85A5FF';
        }

        return status ? '#52C41A' : '#2F54EB';
    }};

    border: ${({ status, theme }) => {
        if (theme.theme === 'dark') {
            return status ? '2px solid #389E0D' : '2px solid #2F54EB';
        }

        return status ? '2px solid #B7EB8F' : '2px solid #ADC6FF';
    }};
`;
